import React from "react";
import "../Auth.css";
import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  getAdditionalUserInfo
} from "firebase/auth";
import { auth , db } from "../../../firebase-config";
import LoadScreen from "../../LoadScreen";
import loader from "../../../images/main-loader.jpg";
import { doc ,getDoc } from "firebase/firestore";

const SendResetPasswordEmail = () => {
  const [registerEmail, setRegisterEmail] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const register = async (event) => {
    event.preventDefault();

    const userExist = await getDoc(doc(db, "userInfo", registerEmail))

    // if(userExist){
      try {
        const resetEmail = await  sendPasswordResetEmail(auth , registerEmail)
        // console.log("current User = " + JSON.stringify(auth.currentUser));
        setErrorMsg("");
        setEmailErrorMsg("");
        setIsLoading(true);
        setSuccessMsg("Reset Password Email Sent Successfully !!");
        // console.log(auth.currentUser.email);
  
        setTimeout(() => {
          setIsLoading(false);
          // console.log("Tried nav");
        }, 2000);
  
        setRedirect(true);
      } catch (error) {
        setRedirect(false);
        if(error.message == "Firebase: Error (auth/user-not-found).")
          setErrorMsg('User Not Found')

        if (registerEmail.length == 0) {
          setEmailErrorMsg("Email cannot be empty");
        }
  
        if (
          registerEmail.length != 0 &&
          error.message == "Firebase: Error (auth/invalid-email)."
        ) {
          setEmailErrorMsg("Invalid Email Used");
        } 
        setSuccessMsg("");
        // console.log(error.message);
      }

    setTimeout(() => {
      setErrorMsg("");
      setEmailErrorMsg("");
    }, 7000);
  };

  const renderRedirect = () => {
    if (redirect) return <Navigate to="/ResetMailSent" />;
  };
  return (
    <>
      {isLoading ? (
        <LoadScreen />
      ) : (
        <div className="createAcDiv">
          {/* v1!edangsar */}
          <section id="contact">
            <div className="contact-box">
              <div className="contact-links">
                <h2 className="signUpHeader">Reset Password</h2>
                <img src={loader} height="150px" width="100%" alt="AVION" />
                <div className="createAcSpan">
                  You will receive an email to reset your password 
                </div>
              </div>

              <div className="contact-form-wrapper">
                {successMsg && (
                  <>
                    <div className="successDiv">{successMsg}</div>
                  </>
                )}
                {errorMsg && (
                  <>
                    <div className="errorDiv">{errorMsg}</div>
                  </>
                )}
                <form className="signUpForm" method="POST">
                  {renderRedirect()}
                  <div className="form-item">
                    <input
                      className="inputFields"
                      type="text"
                      onChange={(event) => {
                        setRegisterEmail(event.target.value);
                      }}
                      value={registerEmail}
                      name="email"
                      required
                    />
                    <label>Email</label>
                    <div className="inputErrors">{emailErrorMsg}</div>
                  </div>

                  <button onClick={register} className="submit-btn">
                    Send Password Reset Email
                  </button>
                </form>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default SendResetPasswordEmail;
